import { render } from "./st-custom.vue?vue&type=template&id=7e369160"
import script from "./st-custom.vue?vue&type=script&lang=js"
export * from "./st-custom.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\tnism\\Documents\\Projects\\MiniApp\\miniapp_wing\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__